import {Observable} from 'rxjs/Observable';
import {HttpClient} from "@angular/common/http";
import {ReportType, ReportTypes} from "../report-type";

export const CUSTOMER_STATEMENT_REPORT_GROUP_ID = 0;

export abstract class ReportTypesService {

    private reportTypesMap: Map<number, Array<ReportType>> = new Map<number, Array<ReportType>>();

    constructor(private _http: HttpClient, private context) {
    }

    getReportTypesByGroupId(groupId: number): Observable<Array<ReportType>> {
        return this.getReasons(`/api/${this.context}/dictionary/report_types/${groupId}`, groupId, this.reportTypesMap);
    }

    private getReasons(url: string, groupId: number, cache: Map<number, Array<ReportType>>): Observable<Array<ReportType>> {
        if (cache.has(groupId)) {
            return Observable.of(cache.get(groupId));
        }
        return this._http.get<ReportTypes>(url)
            .map(response => {
                let reasons = response.records;
                cache.set(groupId, reasons);
                return reasons;
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/report-types.service.ts